import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

export default function PreferencesPage() {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => { api.get("/me/preferences").then((r) => setPrefs(r.data)); }, []);

  const toggle = async (k, v) => {
    try {
      const r = await api.patch("/me/preferences", { [k]: v });
      setPrefs(r.data);
      toast.success("Preferences saved");
    } catch { toast.error("Could not save"); }
  };

  if (!prefs) return <div className="container-page py-16 text-muted-foreground">Loading…</div>;

  return (
    <div className="container-page py-12" data-testid="preferences-page">
      <Link to="/dashboard" className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:text-accent">
        <ArrowLeft className="h-4 w-4" /> Back to dashboard
      </Link>
      <h1 className="mt-6 font-display text-4xl font-bold text-primary lg:text-5xl">Email preferences</h1>
      <p className="mt-2 text-muted-foreground">Control what we send you.</p>

      <div className="card-surface mt-8 p-6">
        <label className="flex items-start gap-3" data-testid="optout-toggle">
          <input
            type="checkbox"
            checked={!prefs.email_optout}
            onChange={(e) => toggle("email_optout", !e.target.checked)}
            className="mt-1"
            data-testid="optout-checkbox"
          />
          <div>
            <div className="font-semibold text-primary">Receive email from {`Black Health Resources`}</div>
            <div className="mt-1 text-sm text-muted-foreground">
              Newsletters, drip onboarding, and listing-related transactional emails. Critical security messages
              (password reset, login alerts) will always be delivered regardless of this setting.
            </div>
          </div>
        </label>
      </div>
    </div>
  );
}
